import React from 'react';
import { TopNecoStrip } from '../../../types/api';
import TopTopics from '../TopTopics';
import StripWrapper from './StripWrapper';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

export interface Props {
  strip: TopNecoStrip;
  isSearchPage?: boolean;
  className?: string;
}

export const TopicStrip: React.FC<Props> = props => {
  const { strip, isSearchPage, className } = props;

  const { ref, dimensions } = useMeasureElementCookie(
    MeasuredCookieType.TOPICS_STRIP,
    { cookieDim: 'width' }
  );

  return (
    <StripWrapper
      strip={strip}
      isSearchPage={isSearchPage}
      className={className}
    >
      <div ref={ref}>
        <TopTopics
          topTopics={strip.topNecos}
          availableWidth={dimensions.width}
        />
      </div>
    </StripWrapper>
  );
};
TopicStrip.displayName = 'TopicStrip';

export default TopicStrip;
